import { render, staticRenderFns } from "./EhpAccordian.vue?vue&type=template&id=6560ad46&scoped=true"
import script from "./EhpAccordian.vue?vue&type=script&lang=js"
export * from "./EhpAccordian.vue?vue&type=script&lang=js"
import style0 from "./EhpAccordian.vue?vue&type=style&index=0&id=6560ad46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6560ad46",
  null
  
)

export default component.exports